import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useI18n } from "../i18n/LanguageContext";
import { useConsent } from "../consent/ConsentContext";
import { Mail, MapPin, Phone } from "lucide-react";

export function Footer() {
  const { t } = useI18n();
  const { reopen } = useConsent();
  return (
    <footer className="border-t border-border bg-secondary/40 mt-24" data-testid="site-footer">
      <div className="container-wide py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 text-sm text-muted-foreground max-w-sm leading-relaxed">{t.footer.tagline}</p>
          <p className="mt-3 text-xs uppercase tracking-[0.22em] text-accent font-bold">{t.common.benelux}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.22em] font-bold text-foreground mb-4">{t.footer.navTitle}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-accent transition-colors">{t.nav.home}</Link></li>
            <li><Link to="/diensten" className="hover:text-accent transition-colors">{t.nav.services}</Link></li>
            <li><Link to="/expat-housing" className="hover:text-accent transition-colors">{t.nav.expat}</Link></li>
            <li><Link to="/bedrijfspanden" className="hover:text-accent transition-colors">{t.nav.business}</Link></li>
            <li><Link to="/tarieven" className="hover:text-accent transition-colors">{t.nav.pricing}</Link></li>
            <li><Link to="/dossiers" className="hover:text-accent transition-colors">{t.nav.cases}</Link></li>
            <li><Link to="/faq" className="hover:text-accent transition-colors">{t.nav.faq}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.22em] font-bold text-foreground mb-4">{t.footer.contactTitle}</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 mt-0.5 text-accent" /> Robert Schumandomein 2, 6229ES Maastricht</li>
            <li className="flex items-start gap-2.5"><Mail className="h-4 w-4 mt-0.5 text-accent" /> hello@tiptopproperty.eu</li>
            <li className="flex items-start gap-2.5"><Phone className="h-4 w-4 mt-0.5 text-accent" /> +31 85 115 57 54</li>
          </ul>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="mt-6 inline-flex items-center gap-1.5 bg-accent text-accent-foreground text-sm font-medium px-4 py-2 rounded-md hover:bg-accent/90 transition-colors"
          >
            {t.nav.requestSearch}
          </Link>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container-wide py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-muted-foreground">
          <div className="flex flex-col gap-1">
            <p>© {new Date().getFullYear()} Tip Top Property. {t.footer.rights}</p>
            <p className="text-muted-foreground/80">
              {t.footer.legalEntity}
            </p>
          </div>
          <div className="flex items-center gap-5 flex-wrap">
            <Link to="/privacy" className="hover:text-accent transition-colors" data-testid="footer-privacy">{t.footer.privacy}</Link>
            <Link to="/cookies" className="hover:text-accent transition-colors" data-testid="footer-cookies">{t.footer.cookies}</Link>
            <Link to="/algemene-voorwaarden" className="hover:text-accent transition-colors" data-testid="footer-terms">{t.footer.terms}</Link>
            <button type="button" onClick={reopen} className="hover:text-accent transition-colors" data-testid="footer-cookie-settings">
              {t.cookieBanner.preferences}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
